import { render, staticRenderFns } from "./EmployeeForm.vue?vue&type=template&id=d33c1390&"
import script from "./EmployeeForm.vue?vue&type=script&lang=js&"
export * from "./EmployeeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports